import { render, staticRenderFns } from "./GrupoDialog.vue?vue&type=template&id=35b19ce4&"
import script from "./GrupoDialog.vue?vue&type=script&lang=js&"
export * from "./GrupoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports